import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { BannerConfig, BannerState } from './types';

const initialState: BannerState = {
  visible: false,
  message: '',
  type: 'info',
  dismissible: true,
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    showBanner: (_, { payload }: PayloadAction<BannerConfig>) => ({
      visible: true,
      message: payload.message,
      type: payload.type,
      dismissible: payload.dismissible ?? true,
    }),
    hideBanner: () => initialState,
    updateBanner: (
      state,
      { payload }: PayloadAction<Partial<BannerConfig>>,
    ) => ({
      ...state,
      ...payload,
    }),
  },
});

export const { showBanner, hideBanner, updateBanner } = bannerSlice.actions;
export const bannerReducer = bannerSlice.reducer;
